import {Unknown} from '@shared/api/core/api_schema';

export const MAVISMART_TECMOTION_WEBHOOK = {
  '/webhook': {
    POST: {
      req: Unknown(),
      res: Unknown(),
    },
  },
};
